import { asyncConnect } from 'redux-connect';
import OrganisationInfo from './OrganisationInfo';

const mapStateToProps = state => ({
  nextFormState: state.intermediary.nextFormState,
  proposalStyle: state.intermediary.initialValues.proposalStyle
});

export const Form = asyncConnect([], mapStateToProps, {})(OrganisationInfo);
